import { Helmet } from 'react-helmet';
import { TITLES } from '../types/titles';
import LoginTwoFactorLayout from '../components/login/two-factor';

const LoginTwoFactor = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.LOGIN.TWOFA}</title>
			</Helmet>
			<LoginTwoFactorLayout />
		</>
	);
};

export default LoginTwoFactor;
